import { render, staticRenderFns } from "./GdprDetails.vue?vue&type=template&id=b62a9ef2&"
import script from "./GdprDetails.vue?vue&type=script&lang=js&"
export * from "./GdprDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports